import { Alert, Modal, Select } from 'antd-v5';
import React, { useCallback, useState } from 'react';

// Sentinel for the "Unassigned" option; falsy so it can never collide with a real associate id
const UNASSIGNED_ASSOCIATE = 0;

export const AssignAssociatesModal = ({ isOpen, onClose, onAssign, allAssoc, warning, onUnassign }) => {
  const [selectedAssociate, setSelectedAssociate] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = useCallback(
    e => {
      e?.stopPropagation();
      setSelectedAssociate(null);
      setSearch('');
      onClose();
    },
    [onClose],
  );

  const handleSave = useCallback(async () => {
    if (selectedAssociate === null) {
      return;
    }
    setLoading(true);
    if (selectedAssociate === UNASSIGNED_ASSOCIATE) {
      await onUnassign();
    } else {
      await onAssign(selectedAssociate);
    }
    setLoading(false);
    handleClose();
  }, [selectedAssociate, onAssign, onUnassign, handleClose]);

  return (
    <Modal
      title="Assign Associate"
      open={isOpen}
      onCancel={handleClose}
      onOk={handleSave}
      okText={selectedAssociate === UNASSIGNED_ASSOCIATE ? 'Unassign' : 'Assign'}
      cancelText="Cancel"
      width={400}
      centered
      destroyOnClose
      confirmLoading={loading}
      okButtonProps={{ disabled: selectedAssociate === null }}
    >
      <Select
        placeholder="Select Associate"
        onChange={value => setSelectedAssociate(value)}
        options={[
          ...(onUnassign ? [{ label: 'Unassigned', value: UNASSIGNED_ASSOCIATE }] : []),
          ...allAssoc.map(assoc => ({
            value: assoc.id,
            label: `${assoc?.first_name || ''} ${assoc?.last_name || ''}`,
          })),
        ]}
        style={{
          width: '100%',
          marginTop: 12,
          marginBottom: 12,
        }}
        showSearch
        searchValue={search}
        onSearch={setSearch}
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
      />
      {warning && <Alert message={warning} type="warning" showIcon />}
    </Modal>
  );
};
